import Inputmask from 'inputmask';

const MASK = '(999) 999-9999';
const INPUT_SELECTOR = '.in-phone';

const PhoneInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        Inputmask({
            mask: MASK,
        }).mask($inputs);
    },
};

export default PhoneInput;
